export class HeroImageWithLink {
    render(title, id, href, src, srcset) {
        return `
            <a id="${id}" href="${href}" hreflang="x-default" class="d-flex justify-content-center link-offset-2 link-underline link-underline-opacity-0 w-100">
                <img
                    class="hero-logo img-fluid"
                    src="${src}"
                    srcset="${srcset}"
                    sizes="(max-width: 600px) 256px, (max-width: 960px) 512px, 1024px"
                    alt="${title}"
                    title="${title}"
                    height="auto"
                    decoding="async"
                    />
            </a>
        `;
    }
    toString() {
        return this.render("Derviş Öksüzoğlu", "heroLogoBg", "https://www.github.com/gokacinlar", "../assets/images/static/webp/logo.webp", "../assets/images/static/webp/logo_256x256.webp 256w, ../assets/images/static/webp/logo_512x512.webp 512w, ../assets/images/static/webp/logo.webp 1024w");
    }
}
